import React from 'react';
import get from 'lodash/get';
import { pickBy } from 'lodash';
import { WithMember } from '@quintype/components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { syndicatedSource, checkStoryType } from '../../../helpers/utils';
import {
  impression,
  trackPurchase,
  trackPurchaseFailed,
  // trackPurchaseSuccess
} from '../../../helpers/datalayer-utils';
import UpdateMobileNumber from '../micro-payment/update-mobile-number';
import PaymentOptions from '../micro-payment/payment-options';
import LinkAccount from '../micro-payment/link-account';
import PaymentError from '../micro-payment/payment-error';
import PayNow from '../micro-payment/pay-now';
import PayReadSubscribe from '../micro-payment/pay-read-subscribe';
import PaymentSuccess from '../micro-payment/payment-success';
import MoengageHelper from '../../../helpers/moengage-helper';
import { EVENT_NAMES } from '../../../constants';
import CryptoJS from 'crypto-js';
import './story-payment.m.css';

const PAYMENT_TYPE = {
  simpl: 'simpl',
  paytm: 'paytm_auto_debit',
};

// todo: refactor this whole component(break it in small chunks)
class MeterCrossedSubscribeWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      payRead: true,
      payOptions: false,
      UpdateMobileNumber: undefined,
      linkAccount: false,
      payNow: false,
      paySuccess: false,
      payError: false,
      selectedWallet: '',
      paymentOptions: {},
      isContactUsOpen: false,
      invalidOtp: false,
      isLoading: false,
    };
    this.handleClickpayRead = this.handleClickpayRead.bind(this);
    this.handleClickUpdateNumber = this.handleClickUpdateNumber.bind(this);
    this.handleClickChangeNumber = this.handleClickChangeNumber.bind(this);
    this.handleClickTryAgain = this.handleClickTryAgain.bind(this);
    this.handleClickPayment = this.handleClickPayment.bind(this);
    this.handleClickChangeWallet = this.handleClickChangeWallet.bind(this);
    this.handleClickPayNow = this.handleClickPayNow.bind(this);
    this.handlePaySuccess = this.handlePaySuccess.bind(this);
    this.handlePayError = this.handlePayError.bind(this);
    this.setUser = this.setUser.bind(this);
    this.handleChangeWallet = this.handleChangeWallet.bind(this);
    this.getAssetPlan = this.getAssetPlan.bind(this);
    this.pay = this.pay.bind(this);
    this.contactHandler = this.contactHandler.bind(this);
    this.closeContactUs = this.closeContactUs.bind(this);
    this.getAllPlans = this.getAllPlans.bind(this);
  }

  componentDidMount() {
    global.Moengage && MoengageHelper.hardPayWallAttributes();
    global.AccessType &&
      this.getAllPlans().then((products) => {
        impression(products);
      });
    this.props.hardPayWallEnabled();
  }
  /* eslint-disable */
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.story.id !== nextProps.story.id) {
      global.AccessType && this.getAssetPlan(nextProps.story.id);
    }
    if (nextProps.member === null) {
      this.setState({
        payRead: true,
        payOptions: false,
        UpdateMobileNumber: undefined,
        linkAccount: false,
        payNow: false,
        paySuccess: false,
        payError: false,
      });
    }
  }

  /* eslint-enable */
  setUser() {
    if (!this.props.member) return null;
    if (!this.props.member.metadata || !this.props.member.metadata['phone-number']) {
      this.setState({ UpdateMobileNumber: 'Set', payOptions: false });
      return null;
    }
    this.setState(
      {
        paymentOptions: {
          paytm: false,
          simpl: false,
        },
        isLoading: true,
      },
      () => {
        let header = {
          alg: 'HS256',
          typ: 'JWT',
        };
        let stringifiedHeader = CryptoJS.enc.Utf8.parse(JSON.stringify(header));
        let encodedHeader = base64url(stringifiedHeader);
        let data = {
          email: 'vaibhav5khanna@gmail.com',
          id: 'vaibhav5khanna@gmail.com',
          provider: 'email',
          name: 'Vaibhav',
        };
        let stringifiedData = CryptoJS.enc.Utf8.parse(JSON.stringify(data));
        let encodedData = base64url(stringifiedData);

        let token = encodedHeader + '.' + encodedData;

        let secret = 'ACCESSTYPE_SECRET';
        let signature = CryptoJS.HmacSHA256(token, secret);
        signature = base64url(signature);
        let signedToken = token + '.' + signature;
        return (
          global.AccessType &&
          global.AccessType.setUser({
            accesstypeJwt: signedToken,
          }).then(() =>
            global.AccessType.getPaymentOptions()
              .then((response) => {
                const paymentOptions = pickBy(response, (value, key) => key === 'razorpay');
                this.setState({
                  isLoading: false,
                  paymentOptions,
                  paymentOptionsLength: Object.keys(paymentOptions).length,
                });
              })
              .catch((error) => this.handlePayError(error))
          )
        );
      }
    );
  }

  getAssetPlan(storyId) {
    return global.AccessType.getAssetPlans({
      id: storyId,
      type: 'story',
    }).then((response) => {
      this.setState({ assetPlan: response[0] });
    });
  }

  getAllPlans() {
    const products = [];
    const macroPlans = [];
    const subscriptionPlansPromise =
      global.AccessType &&
      global.AccessType.getSubscriptionPlans().then((subscriptionPlans) => {
        subscriptionPlans.map((plan) => {
          products.push({
            name: plan.title,
            id: plan.id,
            price: plan.price_cents / 100,
            brand: this.props.story['story-template'] || 'text',
            category: 'Macro Plan',
            variant: checkStoryType(this.props.story),
            quantity: '1',
          });
          macroPlans.push({
            name: plan.title,
            id: plan.id,
            price: plan.price_cents / 100,
            brand: this.props.story['story-template'] || 'text',
            category: 'Macro Plan',
            variant: checkStoryType(this.props.story),
            quantity: '1',
          });
        });
        this.setState({ macroPlans: macroPlans });
      });

    const assetPlanPromise =
      global.AccessType &&
      this.getAssetPlan(this.props.story.id).then(() => {
        products.push({
          name: this.state.assetPlan.duration_unit,
          id: this.state.assetPlan.id,
          price: this.state.assetPlan.price_cents / 100,
          brand: this.props.story['story-template'] || 'text',
          category: 'Micro Plan',
          variant: checkStoryType(this.props.story),
          quantity: '1',
        });
        this.setState({
          microPlan: {
            name: this.state.assetPlan.duration_unit,
            id: this.state.assetPlan.id,
            price: this.state.assetPlan.price_cents / 100,
            brand: this.props.story['story-template'] || 'text',
            category: 'Micro Plan',
            variant: 'NA',
            quantity: '1',
          },
        });
      });

    const promises = [subscriptionPlansPromise, assetPlanPromise];
    return Promise.all(promises).then(() => products);
  }

  static getSubscriptionParams(assetPlan, story, selectedWallet) {
    return {
      plan: Object.assign({}, assetPlan, { title: 'Bloomberg Quint' }),
      assets: [
        {
          id: story.id,
          title: story.headline,
          slug: story.slug,
        },
      ],
      type: 'dynamic_asset',
      payment: {
        payment_type: PAYMENT_TYPE[selectedWallet],
        amount_cents: assetPlan.price_cents,
        amount_currency: assetPlan.price_currency,
      },
    };
  }

  handleClickpayRead() {
    this.setState({
      payRead: false,
      payOptions: true,
      UpdateMobileNumber: undefined,
    });
  }

  handleClickPayment(selectedWallet) {
    this.setState({
      payOptions: false,
      payNow: true,
      selectedWallet,
    });
  }

  async pay(otpNumber) {
    let { paymentOptions } = this.state;
    if (
      paymentOptions[this.state.selectedWallet] &&
      paymentOptions[this.state.selectedWallet].action === 'send_otp'
    ) {
      this.setState({ isLoading: true });
      paymentOptions = await paymentOptions[this.state.selectedWallet].proceed();
      this.setState({
        linkAccount: true,
        payNow: false,
        payOptions: false,
        paymentOptions,
        isLoading: false,
      });
      return paymentOptions;
    }
    if (
      paymentOptions.action === 'link' ||
      (paymentOptions[this.state.selectedWallet] &&
        paymentOptions[this.state.selectedWallet].action === 'link')
    ) {
      if (this.state.selectedWallet === 'paytm') {
        try {
          this.setState({ isLoading: true });
          paymentOptions = await paymentOptions.proceed(
            this.state.selectedWallet === 'paytm' && otpNumber
          );
          this.setState({
            invalidOtp: false,
            isLoading: false,
          });
        } catch (error) {
          console.error(error);
          this.setState({
            invalidOtp: true,
            isLoading: false,
          });
          return paymentOptions;
        }
      }
      if (this.state.selectedWallet === 'simpl') {
        this.setState({ isLoading: true });
        paymentOptions = await paymentOptions[this.state.selectedWallet].proceed();
      }
      this.setState({
        linkAccount: false,
        payNow: true,
        payOptions: false,
        paymentOptions,
        isLoading: false,
      });
      return paymentOptions;
    }
    if (paymentOptions.action === 'pay') {
      try {
        this.setState({ isLoading: true });
        const paySuccessReponse = await paymentOptions.proceed(
          MeterCrossedSubscribeWidget.getSubscriptionParams(
            this.state.assetPlan,
            this.props.story,
            this.state.selectedWallet
          )
        );
        this.handlePaySuccess(paySuccessReponse);
      } catch (errorResponse) {
        this.handlePayError(errorResponse);
      }
    }
    if (
      paymentOptions[this.state.selectedWallet] &&
      paymentOptions[this.state.selectedWallet].action === 'pay'
    ) {
      this.setState({ isLoading: true });
      paymentOptions[this.state.selectedWallet]
        .proceed(
          MeterCrossedSubscribeWidget.getSubscriptionParams(
            this.state.assetPlan,
            this.props.story,
            this.state.selectedWallet
          )
        )
        .then((response) => this.handlePaySuccess(response))
        .catch((errorResponse) => this.handlePayError(errorResponse));
    }
  }

  handleClickTryAgain() {
    this.setState({ payOptions: true, payError: false });
  }

  handleClickChangeWallet() {
    this.setState({ payOptions: true, linkAccount: false });
  }

  handleClickChangeNumber(numberStatus) {
    this.setState({
      payOptions: false,
      linkAccount: false,
      UpdateMobileNumber: numberStatus,
    });
  }

  handleClickUpdateNumber() {
    this.setState({ UpdateMobileNumber: undefined, payOptions: true });
  }

  handleClickPayNow(otpNumber) {
    global.Moengage &&
      MoengageHelper.walletLinkedStatusAttribute({ status: 'linked', name: 'paytm' });
    this.pay(otpNumber);
  }

  handlePaySuccess(successResponse) {
    const subscription = get(successResponse, ['subscription']);
    const invoice = get(subscription, ['invoices', '0'], '');
    const eventData = {
      subscription_id: get(subscription, ['id']),
      sequenced_invoice_number: get(invoice, ['sequenced_invoice_number'], ''),
      created_at: get(invoice, ['created_at'], ''),
      payment_type: get(subscription, ['payment_type']),
      article_title: get(subscription, ['dynamic_assets', '0', 'title']),
      article_price: get(subscription, ['plan_amount_cents'], 0) / 100,
      base_price: get(invoice, ['base_price'], ''),
      discount_amount: get(invoice, ['discount_details', 'discount_amount'], ''),
      discount_percentage: get(invoice, ['discount_details', 'discount_percentage'], ''),
      total_price: get(invoice, ['amount_after_discount_before_tax'], ''),
      CGST: get(invoice, ['invoice_taxes', 'CGST', 'amount'], ''),
      SGST: get(invoice, ['invoice_taxes', 'SGST', 'amount'], ''),
      payment_amount: get(subscription, ['payment_amount']),
    };
    global.Moengage && global.Moengage.track_event('Purchase_Micro_Success', eventData);
    global.Moengage &&
      MoengageHelper.ppaConvesionStoryAttribute(
        get(subscription, ['dynamic_assets', '0', 'title'])
      );

    const actionField = {
      id: get(subscription, ['payment_id']),
      affiliation: 'NA',
      revenue: get(subscription, ['payment_amount']),
      tax:
        get(invoice, ['invoice_taxes', 'CGST', 'amount'], 0) +
        get(invoice, ['invoice_taxes', 'SGST', 'amount'], 0),
      shipping: 0,
      coupon: get(subscription, ['discount_detail', 'code']) || 'NA',
    };

    const datalayerFields = {
      name: this.state.assetPlan.duration_unit,
      id: this.state.assetPlan.id,
      price: this.state.assetPlan.price_cents / 100,
      brand: this.props.story['story-template'] || 'text',
      category: 'Micro Plan',
      variant: checkStoryType(this.props.story),
      quantity: '1',
      dimension7: 'NA',
      dimension11: 'Logged In',
      dimension12: 'Banner',
      dimension13: 'Bottom Sticky',
      dimension14: 'NA',
      dimension15: `${this.props.story.headline}`,
      dimension16: this.props.story['story-template'] || 'text',
      dimension17: this.props.story.sections[0].name,
      dimension18: 'NA',
      dimension19: this.props.story['author-name'],
      dimension20: (this.props.story.tags || []).map((t) => t.name).join(' | '),
      dimension21: syndicatedSource(this.props.story),
    };
    trackPurchase(actionField, datalayerFields);
    // trackPurchaseSuccess();
    global.Moengage && MoengageHelper.purchase(EVENT_NAMES.PURCHASE_MICRO, subscription, invoice);
    this.setState({ payNow: false, paySuccess: true, isLoading: false });
    setTimeout(() => this.props.updateAccess(), 4000);
  }

  handlePayError(response) {
    trackPurchaseFailed();
    this.setState({
      payNow: false,
      payError: true,
      payErrorResponse: response,
      isLoading: false,
    });
  }

  handleChangeWallet() {
    this.setState({ payNow: false, payOptions: true });
  }

  contactHandler() {
    this.setState({
      isContactUsOpen: true,
    });
  }

  closeContactUs() {
    this.setState({
      isContactUsOpen: false,
    });
  }

  render() {
    console.log(
      'Story Paywall===>>>',
      this.state.payRead,
      this.state.payOptions,
      this.state.payNow,
      this.state.payError
    );
    return (
      <React.Fragment>
        {this.state.payRead && (
          <WithMember>
            {({ checkForMemberUpdated }) => (
              <PayReadSubscribe
                payRead={this.handleClickpayRead}
                userLoggedIn={!!this.props.member}
                reloadMember={checkForMemberUpdated}
                story={this.props.story}
                assetPlan={this.state.assetPlan}
                subscribeUrl={this.props.subscribeUrl}
                macroPlans={this.state.macroPlans}
                microPlan={this.state.microPlan}
                privateMode={this.props.privateMode}
              />
            )}
          </WithMember>
        )}
        {this.state.payOptions && (
          <PaymentOptions
            changeNumber={this.handleClickChangeNumber}
            payment={this.handleClickPayment}
            setUser={this.setUser}
            paymentOptions={this.state.paymentOptions}
            isLoading={this.state.isLoading}
            mobileNumber={this.props.member?.metadata?.['phone-number']}
            assetPlan={this.state.assetPlan}
            story={this.props.story}
          />
        )}
        {this.state.UpdateMobileNumber && (
          <WithMember>
            {({ checkForMemberUpdated }) => (
              <UpdateMobileNumber
                payRead={this.handleClickpayRead}
                reloadMember={checkForMemberUpdated}
                updateNumber={this.handleClickUpdateNumber}
                UpdateMobileNumber={this.state.UpdateMobileNumber}
                mobileNumber={this.props.member.metadata['phone-number']}
              />
            )}
          </WithMember>
        )}
        {this.state.linkAccount && (
          <LinkAccount
            changeWallet={this.handleClickChangeWallet}
            payNow={this.handleClickPayNow}
            paymentOptionsLength={this.state.paymentOptionsLength}
            invalidOtp={this.state.invalidOtp}
            isLoading={this.state.isLoading}
          />
        )}
        {this.state.payNow && (
          <PayNow
            member={this.props.member}
            assetPlan={this.state.assetPlan}
            story={this.props.story}
            paymentOptions={this.state.paymentOptions}
            selectedWallet={this.state.selectedWallet}
            changeWallet={this.handleChangeWallet}
            pay={this.pay}
            paymentOptionsLength={this.state.paymentOptionsLength}
            isLoading={this.state.isLoading}
            mobileNumber={this.props.member.metadata['phone-number']}
          />
        )}
        {this.state.payError && (
          <PaymentError
            tryAgain={this.handleClickTryAgain}
            errorResponse={this.state.payErrorResponse}
            contactHandler={this.contactHandler}
            isContactUsOpen={this.state.isContactUsOpen}
            closeContactUs={this.closeContactUs}
          />
        )}
        {this.state.paySuccess && <PaymentSuccess />}
      </React.Fragment>
    );
  }
}

MeterCrossedSubscribeWidget.propTypes = {
  member: PropTypes.objectOf(PropTypes.any),
  story: PropTypes.objectOf(PropTypes.any).isRequired,
  updateAccess: PropTypes.func.isRequired,
  subscribeUrl: PropTypes.string,
  privateModeEnabled: PropTypes.bool.isRequired,
  hardPayWallEnabled: PropTypes.func,
  privateMode: PropTypes.bool,
};

MeterCrossedSubscribeWidget.defaultProps = {
  member: {},
};

const mapStateToProps = (state) => {
  const { member } = state;
  return { member };
};

function mapDispatchToProps(dispatch) {
  return {
    hardPayWallEnabled: () => {
      dispatch({
        type: 'BQ_HARDPAYWALL_ENABLED',
      });
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MeterCrossedSubscribeWidget);
